import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
@Pipe({
    name: 'moment'
})
export class MomentPipe implements PipeTransform {

    constructor() {
    }

    transform(value: moment.Moment | string, format: string): string {
        let m: moment.Moment;
        if (typeof value === 'string') {
            m = moment.utc(value);
        } else {
            m = value;
        }
        return m.format(format);
    }
}
